export enum VerticalTypeEnum {
  ChamberOfCommerce = 1,
  Association = 2,
  ApartmentAssociation = 3,
  HBA = 4,
  AssociatedBuildersAndContractors = 5,
  RestaurantAssociation = 6,
}
